import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { ReflectionPanel } from "@webapp/reflections/models/reflection-panel.models";
import { ReflectionOrder } from "@webapp/reflections/models/reflection-question.model";

@Component({
  selector: "checkin-action-buttons[checkIn][type][isCheckInEmpty]",
  templateUrl: "./checkin-action-buttons.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckinActionButtonsComponent {
  @Input() public checkIn: ReflectionPanel;
  @Input() public type: ReflectionOrder;
  @Input() public isCheckInEmpty: boolean;

  @Output() public readonly checkInPublish = new EventEmitter<ReflectionOrder>();
  @Output() public readonly checkInEdit = new EventEmitter<ReflectionOrder>();
  @Output() public readonly checkInCancel = new EventEmitter<ReflectionOrder>();
}
